module.exports = __webpack_public_path__ + "img/circle_close_outline.1676e01f.svg";